import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { ToastContainer } from "react-toastify";
// Import CSS here
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import store from "./store/index";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://fcbbc299e2bbe06daffaa2644cc349ff@o4507571489210368.ingest.de.sentry.io/4509054350196816",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0
  });
}

ReactDOM.render(
  <Provider store={store}>
    <Sentry.ErrorBoundary
      fallback={
        <div className="d-flex flex-column align-items-center justify-content-center text-danger py-10">
          <div className="fw-bold text-center fs-1">
            Something went wrong. Please try again later. 🚨
          </div>
        </div>
      }
    >
      <ToastContainer />
      <App />
    </Sentry.ErrorBoundary>
  </Provider>,
  document.getElementById("root")
);
